<div class="mt-modal">
  <div class="modal-head">
    <div class="title-block">
      <h2>
        <i class="bi bi-calendar-x"></i>
        Missing Timesheets
        <span class="count">{{ allMissingTimesheets?.length || 0 }}</span>
      </h2>
      <div class="sub">Contractors who haven't submitted yet.</div>
    </div>
    <button type="button" class="close-btn" (click)="close()" title="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="mt-table-wrap" *ngIf="allMissingTimesheets?.length; else mtEmpty">
      <table class="mt-table">
        <thead>
          <tr>
            <th>Contractor</th>
            <th>Job</th>
            <th>Client</th>
            <th class="actions-col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let missingTimesheet of allMissingTimesheets; let i = index">
            <td>
              <div class="cell-contractor">
                <div class="avatar">
                  <img *ngIf="missingTimesheet.profile_pic"
                       [src]="dataSharedService.getImage(missingTimesheet.profile_pic)"
                       [alt]="missingTimesheet.candidate" />
                  <span *ngIf="!missingTimesheet.profile_pic">
                    {{ authService.getInitials(missingTimesheet.candidate) }}
                  </span>
                </div>
                <span class="name">{{ missingTimesheet.candidate }}</span>
              </div>
            </td>
            <td>{{ missingTimesheet.job }}</td>
            <td>{{ missingTimesheet.client }}</td>
            <td class="actions-col">
              <div class="row-actions">
                <button type="button" class="icon-btn-sm"
                  title="Send reminder"
                  (click)="openSendReminderPopUp(missingTimesheet.candidate_uuid, missingTimesheet.candidate_first_name, missingTimesheet.job, missingTimesheet.client)">
                  <i class="bi bi-envelope"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #mtEmpty>
      <div class="mt-empty">
        <div class="ico"><i class="bi bi-calendar-check"></i></div>
        <h4>All caught up</h4>
        <p>No missing timesheets right now.</p>
      </div>
    </ng-template>
  </div>
</div>
